import BannerComponent from "./components/Banner"
import BrandsComponent from "./components/Brands/index"
import CommitmentsComponent from "./components/Commitments"
import FooterComponent from "./components/Footer"
import HeaderComponent from "./components/Header"
import PillarsComponent from "./components/Pillars"
import PolicySustainabilityComponent from "./components/PolicySustainability/indesx"
import RecognitionComponent from "./components/Recognition"
import ReportComponent from "./components/Report"
import TrocComponent from "./components/TrocWrapper"

function App() {
  return (
    <>
      <HeaderComponent />
      <BannerComponent />
      <PillarsComponent />
      <CommitmentsComponent />
      <PolicySustainabilityComponent />
      <ReportComponent />
      <RecognitionComponent />
      <TrocComponent />
      <BrandsComponent />
      <FooterComponent />
    </>

  )
}

export default App
